// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bigNumIsLoading{
    width: 100%;
    height: 44px;
    margin: 1em 0;
    background: linear-gradient(to right, rgba(131, 131, 131, 0), rgb(66, 66, 66), rgba(131, 131, 131, 0));
    animation-name: pulse;
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-delay: 1ms;
}

.smallIsLoading{
    width: 70%;
    height: 34px;
    margin: 1em auto;
    background: linear-gradient(to right, rgba(131, 131, 131, 0), rgb(66, 66, 66), rgba(131, 131, 131, 0));
    animation-name: pulse;
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-delay: 1ms;
}

.loading-bar{
    width: 100%;
    height: 3px;
    position: absolute;
    top: 0;
    left: 0;
}

.loading-bar-progress-fill{
    width: 0%;
    height: 3px;
    background: linear-gradient(to right, rgba(192, 159, 83, 0), rgb(192, 159, 83), rgb(190, 161, 96), rgb(192, 159, 83, 0));
    animation-name: leftToRight;
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-delay: 1ms;
    position: absolute;
    top: 0;
    left: 0;
}

.loading-bar-progress{
    width: 100%;
    height: 3px;
    background: linear-gradient(to right, rgba(192, 159, 83, 0), rgb(192, 159, 83), rgb(190, 161, 96), rgba(192, 159, 83, 0));
    animation-name: leftToRight;
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-delay: 1ms;
    position: relative;
    overflow: hidden;
}

@keyframes pulse {
    0%   {opacity: .5;}
    50%  {opacity: 1;}
    100% {opacity: .5;}
}

@keyframes leftToRight {
    0%   { width: 0%;   left: 0;   }
    50%  { width: 100%; left: 0;   }
    100% { width: 0%;   left: 100%; }
}

@keyframes rightToLeft {
    0%   {width: 100%;}
    50%  {width: 0%;}
    100% {width: 100%;}
}`, "",{"version":3,"sources":["webpack://./src/Components/widget/Loading.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sGAAsG;IACtG,qBAAqB;IACrB,sBAAsB;IACtB,mCAAmC;IACnC,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sGAAsG;IACtG,qBAAqB;IACrB,sBAAsB;IACtB,mCAAmC;IACnC,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;;AAEA;IACI,SAAS;IACT,WAAW;IACX,wHAAwH;IACxH,2BAA2B;IAC3B,sBAAsB;IACtB,mCAAmC;IACnC,oBAAoB;IACpB,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;;AAEA;IACI,WAAW;IACX,WAAW;IACX,yHAAyH;IACzH,2BAA2B;IAC3B,sBAAsB;IACtB,mCAAmC;IACnC,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,MAAM,WAAW,CAAC;IAClB,MAAM,UAAU,CAAC;IACjB,MAAM,WAAW,CAAC;AACtB;;AAEA;IACI,OAAO,SAAS,IAAI,OAAO,IAAI;IAC/B,OAAO,WAAW,EAAE,OAAO,IAAI;IAC/B,OAAO,SAAS,IAAI,UAAU,EAAE;AACpC;;AAEA;IACI,MAAM,WAAW,CAAC;IAClB,MAAM,SAAS,CAAC;IAChB,MAAM,WAAW,CAAC;AACtB","sourcesContent":[".bigNumIsLoading{\n    width: 100%;\n    height: 44px;\n    margin: 1em 0;\n    background: linear-gradient(to right, rgba(131, 131, 131, 0), rgb(66, 66, 66), rgba(131, 131, 131, 0));\n    animation-name: pulse;\n    animation-duration: 2s;\n    animation-iteration-count: infinite;\n    animation-delay: 1ms;\n}\n\n.smallIsLoading{\n    width: 70%;\n    height: 34px;\n    margin: 1em auto;\n    background: linear-gradient(to right, rgba(131, 131, 131, 0), rgb(66, 66, 66), rgba(131, 131, 131, 0));\n    animation-name: pulse;\n    animation-duration: 2s;\n    animation-iteration-count: infinite;\n    animation-delay: 1ms;\n}\n\n.loading-bar{\n    width: 100%;\n    height: 3px;\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n\n.loading-bar-progress-fill{\n    width: 0%;\n    height: 3px;\n    background: linear-gradient(to right, rgba(192, 159, 83, 0), rgb(192, 159, 83), rgb(190, 161, 96), rgb(192, 159, 83, 0));\n    animation-name: leftToRight;\n    animation-duration: 2s;\n    animation-iteration-count: infinite;\n    animation-delay: 1ms;\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n\n.loading-bar-progress{\n    width: 100%;\n    height: 3px;\n    background: linear-gradient(to right, rgba(192, 159, 83, 0), rgb(192, 159, 83), rgb(190, 161, 96), rgba(192, 159, 83, 0));\n    animation-name: leftToRight;\n    animation-duration: 2s;\n    animation-iteration-count: infinite;\n    animation-delay: 1ms;\n    position: relative;\n    overflow: hidden;\n}\n\n@keyframes pulse {\n    0%   {opacity: .5;}\n    50%  {opacity: 1;}\n    100% {opacity: .5;}\n}\n\n@keyframes leftToRight {\n    0%   { width: 0%;   left: 0;   }\n    50%  { width: 100%; left: 0;   }\n    100% { width: 0%;   left: 100%; }\n}\n\n@keyframes rightToLeft {\n    0%   {width: 100%;}\n    50%  {width: 0%;}\n    100% {width: 100%;}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
